import { Component, OnInit } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';

@Component({
  selector: 'app-booking-order',
  templateUrl: './booking-order.component.html',
  styleUrls: ['./booking-order.component.css']
})
export class BookingOrderComponent implements OnInit {

  constructor(
    protected bookingStepService: BookingStepService,
  ) {
  }

  ngOnInit(): void {
  }

  onNext(): void {
    this.bookingStepService.forward();
  }

  onBack(): void {
    this.bookingStepService.back();
  }
}
